export const datesSearch = {
  consumption_start_at: 'Período Consumo (Data Início)',
  consumption_end_at: 'Período Consumo (Data Fim)',
  published_start_at: 'Publicação (De)',
  published_end_at: 'Publicação (Até)',
  review_start_at: 'Expiração (De)',
  review_end_at: 'Expiração (Até)'
}